module.exports = "../../app/cells/components/lesson_player/faq_cell.rb";